<template>
<div class="copy-popup-background" @click="close($event)">
    <div class="copy-popup">
        <div class="copy-popup__body">
            <div class="popup-group">
                <div class="popup-group__column">
                </div>
                <div class="popup-group__column">
                    <h1>Przenieś do:</h1>
                    <div class="row">
                        <div class="col-4 col-temporary">
                            <div class="form-group">
                                <label class="checkbox"><input type="checkbox" v-model="waiting" @change="checkBox('waiting')"/><span class="checkmark"></span>Poczekalnia</label>
                            </div>
                        </div>
                        <div class="col-4 col-temporary">
                            <div class="form-group">
                                <label class="checkbox"><input type="checkbox" v-model="page" @change="checkBox('page')"/><span class="checkmark"></span>inna strona</label>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="form-group" :class="{'disabled': waiting}">
                                <label>nr strony</label>
                                <vueselect style="max-width:45px;" class="select--list select--list-small select--list-status select--list--footer page-select" label="number" v-model="selected" :clearable="false" :options="pages" :searchable="true">
                                    <template slot="option" slot-scope="option">
                                        <div>{{option.number}}</div>
                                    </template>
                                    <template slot="no-options">
                                        <p>Brak rekordów</p>
                                    </template>
                                </vueselect>
                                <labelInfo  type="error" message="To pole jest wymagane"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="popup-group">
                <div class="popup-group__column">
                </div>
                <div class="popup-group__column">
                    <div class="copy-popup__footer">
                        <button class="button-normal button-normal--media" :class="{'disabled-option': !waiting && !page || waiting && page || page && !selected}" @click="confirm()">PRZENIEŚ</button>
                        <button class="button-normal button-normal--cancel" @click="$emit('cancel')">ANULUJ</button>
                    </div>
                </div>
            </div>
        </div>
      </div>
</div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, numeric, maxLength } from 'vuelidate/lib/validators'
import labelInfo from '@/components/blocks/labelInfo.vue';
import debounce from "lodash.debounce";
import { setTimeout } from 'timers';

export default {

    name: 'moveProductsPopup',
    components:{

        labelInfo

    },
    props:{

        pages:{
            type: Array,
            default: () => [],
        }

    },
    mixins: [validationMixin],
    data(){

        return{
            selected:'',
            waiting: true,
            page: false,
        }

    },
    validations: {

    },
    methods:{

        checkBox(box){

            //this.waiting = false;
            //this.page = false;

            if(box == 'waiting' && this.page){
                 this.waiting = true;
                 this.page = false
            }


            if(box == 'page' && this.waiting){
                 this.page = true;
                 this.waiting = false;
            }

        },

        confirm(){

            if(this.page && this.selected && !this.waiting){

                this.$emit('choose', this.selected);

            }

            if(this.waiting && !this.page){

                this.$emit('choose', false);

            }

        },

        close(e){

            if(!e.target.classList.contains('select-search') && !e.target.classList.contains('custom-search-input')){

                let lists = document.querySelectorAll('.select-search');

                if(lists){
                    lists.forEach(element => {
                        element.classList.remove('active')
                    });
                }

            }

        },

    },
    mounted(){

    }

}
</script>

<style lang="scss" scoped>

.copy-popup-background{
    display:flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width:100%;
    height:100%;
    top:0;
    left:0;
    z-index: 200;
}

.popup-group{
    display:flex;

    &__column{
        display:flex;
        flex-direction: column;

        &:nth-child(1){
            width: 7%;
        }

        &:nth-child(2){
            width: 87%;
        }
    }
}

.copy-popup{
  background:#fff;
  border: 1px #d3020c solid;
  width: 500px;

  &__body{
    padding: 20px 10px;
    position:relative;
    display:flex;
    flex-direction: column;

    & h1{
        font-size: 14px;
        font-weight: 400;
        color:#000000;
        opacity: 1;
    }

    & label{
        font-size: 9px;
        margin-bottom:5px;
    }

     & .form-group{
         width:100%;
     }

    & .form-group.page{
        width:50px;
    }

    & .form-group > input{
        font-size: 14px;
        color:#000000;
        opacity:1;
        font-weight: 400;
    }

    & p{
        font-size: 12px;
        color:#E3000B;
    }

    & .checkbox{
        margin-bottom:0px
    }

  }

  &__footer{
      width:100%;
      display:flex;
      flex-direction: column;
      margin-top: 30px;

      & button{
          margin-bottom: 15px;
          height:56px;
      }
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      zoom: 0.9;
    }
}

.select-search{
    position: absolute;
    left: 0;
    margin-bottom: -20px;
    width: auto;
    background: #fff;
    z-index: 3;
    max-height: 400px;
    overflow-x: hidden;
    cursor:pointer;
    visibility: hidden;

    &.active{
        visibility: visible;
    }

    & ul{
        list-style: none;
        padding:0;
        margin:0;

        & li{
            padding:10px 5px;
            &:nth-child(odd){
                background:#edf7ff
            }
        }
    }

    &::-webkit-scrollbar-track{
    border-radius: 10px;
    background-color: rgba(226, 229, 235, 0.5);
  }

  &::-webkit-scrollbar{
    width: 5px;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb{
    border-radius: 10px;
    height:50px;
    background-color: #B1B4C1;
  }
}

.disabled-option{
    pointer-events: none;
    opacity: 0.5;
}

.custom-search-input{
    padding-right: 25px;
}

.col-temporary{
    flex-direction: column-reverse;
    display: flex;

    & label{
        font-size: 14px;
    }
}

.form-group.input-error > input {
  height: auto !important;
  padding-bottom: 0 !important;
}

.copy-popup__body .form-group label{
    opacity:1;
}

</style>
